var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryLogo = exports.TeamLogo = exports.CompetitionLogo = exports.LogoWithFallback = exports.CircleLogo = exports.ImageFallback = exports.AssetLogo = exports.Logo = exports.TeaserImage = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Basic = require("../../../../elements/Basic");

var _FontelloIcon = _interopRequireDefault(require("../FontelloIcon"));

var _withImageFallback = _interopRequireDefault(require("../../../../hoc/withImageFallback"));

var _PropsHelper = require("../../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/Logos/index.js";

var TeaserImage = function TeaserImage(_ref) {
  var width = _ref.width,
      height = _ref.height,
      src = _ref.src,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["width", "height", "src"]);
  return _react.default.createElement(_Basic.Image, (0, _extends2.default)({
    source: {
      uri: src
    },
    style: {
      width: width,
      height: height
    },
    src: src
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 5
    }
  }));
};

exports.TeaserImage = TeaserImage;

var Logo = function Logo(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      src = _ref2.src,
      backgroundColor = _ref2.backgroundColor,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["width", "height", "src", "backgroundColor"]);
  return _react.default.createElement(_Basic.Image, (0, _extends2.default)({
    source: {
      uri: src
    },
    style: {
      width: width,
      height: height,
      backgroundColor: '#fff'
    },
    src: src
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }));
};

exports.Logo = Logo;

var AssetLogo = function AssetLogo(_ref3) {
  var width = _ref3.width,
      height = _ref3.height,
      src = _ref3.src,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["width", "height", "src"]);
  return _react.default.createElement(_Basic.Image, (0, _extends2.default)({
    source: src,
    src: src,
    style: {
      width: width,
      height: height
    }
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }));
};

exports.AssetLogo = AssetLogo;

var CircleImage = function CircleImage(_ref4) {
  var size = _ref4.size,
      onError = _ref4.onError,
      src = _ref4.src,
      rest = (0, _objectWithoutProperties2.default)(_ref4, ["size", "onError", "src"]);
  return _react.default.createElement(_Basic.View, {
    bg: "white",
    borderColor: "border.main",
    style: {
      borderRadius: size / 2,
      borderWidth: 1,
      overflow: 'hidden',
      borderStyle: 'solid',
      width: size,
      height: size
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.Image, (0, _extends2.default)({
    source: {
      uri: src
    },
    onError: onError,
    style: {
      width: size,
      height: size
    },
    src: src
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  })));
};

var fallbacks = {
  player: 'default-player-circle',
  team: 'default-team',
  competition: 'default-competition',
  country: 'default-country'
};

var CircleImageFallback = function CircleImageFallback(_ref5) {
  var size = _ref5.size,
      _ref5$imageType = _ref5.imageType,
      imageType = _ref5$imageType === void 0 ? 'player' : _ref5$imageType;
  return _react.default.createElement(_Basic.View, {
    borderRadius: size ? size / 2 : 0,
    width: size,
    height: size,
    overflow: "hidden",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 5
    }
  }, _react.default.createElement(_FontelloIcon.default, {
    color: "font.main",
    size: "custom",
    fontSize: size,
    lineHeight: (0, _PropsHelper.getValueConditionally)(size, size + "px"),
    name: fallbacks[imageType],
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 9
    }
  }));
};

var StandardImage = function StandardImage(_ref6) {
  var size = _ref6.size,
      src = _ref6.src,
      onError = _ref6.onError,
      rest = (0, _objectWithoutProperties2.default)(_ref6, ["size", "src", "onError"]);
  return _react.default.createElement(_Basic.Image, (0, _extends2.default)({
    source: {
      uri: src
    },
    onError: onError,
    style: {
      width: size,
      height: size
    },
    src: src
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 5
    }
  }));
};

var ImageFallback = function ImageFallback(_ref7) {
  var size = _ref7.size,
      imageType = _ref7.imageType,
      rest = (0, _objectWithoutProperties2.default)(_ref7, ["size", "imageType"]);
  return _react.default.createElement(_FontelloIcon.default, (0, _extends2.default)({
    color: "font.main",
    size: "custom",
    name: fallbacks[imageType],
    fontSize: size,
    lineHeight: (0, _PropsHelper.getValueConditionally)(size, size + "px")
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 5
    }
  }));
};

exports.ImageFallback = ImageFallback;
var CircleLogo = (0, _withImageFallback.default)(CircleImage, CircleImageFallback);
exports.CircleLogo = CircleLogo;
var LogoWithFallback = (0, _withImageFallback.default)(Logo, CircleImageFallback);
exports.LogoWithFallback = LogoWithFallback;
var CompetitionLogo = (0, _withImageFallback.default)(StandardImage, function (_ref8) {
  var rest = (0, _extends2.default)({}, _ref8);
  return _react.default.createElement(ImageFallback, (0, _extends2.default)({}, rest, {
    imageType: "competition",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 5
    }
  }));
});
exports.CompetitionLogo = CompetitionLogo;
var TeamLogo = (0, _withImageFallback.default)(StandardImage, function (_ref9) {
  var rest = (0, _extends2.default)({}, _ref9);
  return _react.default.createElement(ImageFallback, (0, _extends2.default)({}, rest, {
    imageType: "team",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 5
    }
  }));
});
exports.TeamLogo = TeamLogo;
var CountryLogo = (0, _withImageFallback.default)(Logo, function (_ref10) {
  var rest = (0, _extends2.default)({}, _ref10);
  return _react.default.createElement(ImageFallback, (0, _extends2.default)({}, rest, {
    imageType: "country",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 5
    }
  }));
});
exports.CountryLogo = CountryLogo;